<script lang="ts">
  import { cn } from '@/lib/utils';

  export let direction: 'horizontal' | 'vertical' = 'horizontal';
  export let useMomentum: boolean = true;
  export let className = ''; // Optional: allow user to style container
  let container: HTMLDivElement;

  export let isDown = false;
  export let walk = 0;
  export let isScrollAtEnd: 'left' | 'scrolling' | 'right' = 'left';
  let startX = 0;
  let lastX = 0;
  let scrollLeft = 0;
  let momentum = 0;
  let momentumScrollTimeout;

  function handlePointerDown(event: PointerEvent) {
    isDown = true;
    walk = 0;
    container.classList.add('cursor-grabbing');
    startX = event.pageX - container.offsetLeft;
    lastX = startX;
    scrollLeft = container.scrollLeft;

    clearTimeout(momentumScrollTimeout);
  }

  function handlePointerMove(event: PointerEvent) {
    if (!isDown) return;
    event.preventDefault();
    const x = event.pageX - container.offsetLeft;
    const sens = 1; // Adjust this for sensitivity
    walk = (x - startX) * sens;
    const diff = (x - lastX) * sens;
    container.scrollLeft = scrollLeft - walk;

    if (useMomentum) {
      momentum = diff;
    }
    lastX = x;
  }

  function handlePointerUp() {
    isDown = false;
    walk = 0;
    container.classList.remove('cursor-grabbing');
    if (useMomentum) {
      momentumScrollTimeout = setTimeout(() => {
        momentum = momentum - 1 * Math.sign(momentum);
        container.scrollLeft = container.scrollLeft - momentum;
        if (Math.abs(momentum) > 1) {
          momentumScrollTimeout = setTimeout(arguments.callee, 10);
        } else {
          momentum = 0;
        }
      }, 16);
    }
  }

  function handleScroll() {
    if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 5) {
      isScrollAtEnd = 'right';
    } else if (container.scrollLeft <= 5) {
      isScrollAtEnd = 'left';
    } else {
      isScrollAtEnd = 'scrolling';
    }
  }
</script>

<div
  bind:this={container}
  class={cn(
    `whitespace-nowrap cursor-grab select-none flex gap-2 min-w-0 w-full no-scrollbar ${className}`,
    direction === 'horizontal' ?
      'overflow-x-auto overflow-y-hidden flex-row' :
      'overflow-y-auto overflow-x-hidden flex-col'
  )}
  on:pointerdown={handlePointerDown}
  on:pointermove={handlePointerMove}
  on:pointerup={handlePointerUp}
  on:pointerleave={handlePointerUp}
  on:scroll={handleScroll}
>
  <slot/>
</div>
